<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <img src="../../assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
      <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">Are you sure you want to delete this account ?</h1>
      <div class="flex">
        <vs-button class="mr-4" size="large" @click="confirmDelete()" color="danger" style="background-color: #FF4136; border-color: #FF4136;" title="Confirm Delete">
          <span style="color: white;">Confirm</span>
        </vs-button>
        <vs-button size="large" @click="cancelDelete()" style="background-color: #0074D9; border-color: #0074D9;" title="Cancel Delete">
          <span style="color: white;">Cancel</span>
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Request } from '../../utils/requests'
export default {
  methods: {
    confirmDelete() {
      const payload = {
        is_active:false
      }
     const Token= localStorage.getItem('token')
     const headers = {
      'Authorization': `Token ${Token}`
    };
      Request(this, 'PATCH', this.$store.state.apiendpoints.delete,null,payload,headers,false).then(
        res => {
          if(res.message==="User deleted successfully"){
            this.$vs.notify({
              time: 2500,
              title: 'Success',
              text: 'User deleted successfully.',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color:'success'
            })
            this.$store.dispatch('auth/logout').then(
            () => this.$router.push('/')
        )
          }
        },
      )
    },
    cancelDelete() {
      this.$router.push('/dashboard');
    }
  }
}
</script>
<style scoped>
.bg-img {
  /* Add your background image styles here */
}
.d-theme-heading-color {
  /* Add your heading color styles here */
}
.d-theme-text-inverse {
  /* Add your text color styles here */
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* Tooltip */
.vs-button[title]::after {
  content: attr(title);
  position: absolute;
  bottom: -25px; /* Adjust the distance from the button */
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.vs-button:hover[title]::after {
  opacity: 1;
}
</style>
